// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file api/core/svc_study.proto (package com.diagnocat.core, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { Study } from "../../model/dto_study_pb.js";
import { Patient } from "../../model/dto_patient_pb.js";
import { Organization } from "../../model/dto_organization_pb.js";
import { Asset } from "../../model/dto_asset_pb.js";
import { User } from "../../model/dto_user_pb.js";

/**
 * @generated from message com.diagnocat.core.GetStudyViewerDataReq
 */
export const GetStudyViewerDataReq = proto3.makeMessageType(
  "com.diagnocat.core.GetStudyViewerDataReq",
  () => [
    { no: 1, name: "StudyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.GetStudyViewerDataResp
 */
export const GetStudyViewerDataResp = proto3.makeMessageType(
  "com.diagnocat.core.GetStudyViewerDataResp",
  () => [
    { no: 1, name: "Study", kind: "message", T: Study },
    { no: 2, name: "Patient", kind: "message", T: Patient },
    { no: 3, name: "Organization", kind: "message", T: Organization },
    { no: 4, name: "StudyAssets", kind: "message", T: Asset, repeated: true },
    { no: 5, name: "CurrentUser", kind: "message", T: User },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnsetStudyRawMeshViewerReq
 */
export const UnsetStudyRawMeshViewerReq = proto3.makeMessageType(
  "com.diagnocat.core.UnsetStudyRawMeshViewerReq",
  () => [
    { no: 1, name: "StudyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.UnsetStudyRawMeshViewerResp
 */
export const UnsetStudyRawMeshViewerResp = proto3.makeMessageType(
  "com.diagnocat.core.UnsetStudyRawMeshViewerResp",
  () => [
    { no: 1, name: "Study", kind: "message", T: Study },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeleteStudyReq
 */
export const DeleteStudyReq = proto3.makeMessageType(
  "com.diagnocat.core.DeleteStudyReq",
  () => [
    { no: 1, name: "StudyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.core.DeleteStudyResp
 */
export const DeleteStudyResp = proto3.makeMessageType(
  "com.diagnocat.core.DeleteStudyResp",
  () => [
    { no: 1, name: "DeletedStudyID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "DeletedReportIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "DeletedToothIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "DeletedConditionIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "DeletedTeethLandmarkIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "DeletedAssetIDs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "ChangedPatient", kind: "message", T: Patient },
  ],
);

